// Auto generated file, do not manually modify!
// com.hotpads.rentalmanagerapi.api.web.v1.users.rentercontact.RentalManagerRenterContactWebApiHandler

import type { UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  RentalManagerRenterContactWebApiHandler_getLikelyTenants,
  RentalManagerRenterContactWebApiHandler_getLikelyTenants_Path,
  RentalManagerRenterContactWebApiHandler_getTenancies,
  RentalManagerRenterContactWebApiHandler_getTenancies_Path,
  RentalManagerRenterContactWebApiHandler_getTenants,
  RentalManagerRenterContactWebApiHandler_getTenants_Path,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

import type {
  RentalManagerRenterContactGetLikelyTenantsRequestDto,
  RentalManagerRenterContactGetLikelyTenantsResponseDto,
  RentalManagerRenterContactGetTenanciesRequestDto,
  RentalManagerRenterContactGetTenanciesResponseDto,
  RentalManagerRenterContactGetTenantsRequestDto,
  RentalManagerRenterContactGetTenantsResponseDto,
} from '@zg-rentals/ts-rental-manager-api-beta-client';

export type RentalManagerRenterContactWebApiHandler_getLikelyTenants_Options = UseQueryOptions<
  RentalManagerRenterContactGetLikelyTenantsResponseDto,
  unknown,
  RentalManagerRenterContactGetLikelyTenantsResponseDto,
  Array<string | RentalManagerRenterContactGetLikelyTenantsRequestDto>
>;

const RentalManagerRenterContactWebApiHandler_getLikelyTenants_GetKey = (
  postData: RentalManagerRenterContactGetLikelyTenantsRequestDto,
) => [RentalManagerRenterContactWebApiHandler_getLikelyTenants_Path, postData];

/**
 * Get likely tenants, sorted by probability of being a current tenant
 */
export const useRentalManagerRenterContactWebApiHandler_getLikelyTenants = (
  postData: RentalManagerRenterContactGetLikelyTenantsRequestDto,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerRenterContactWebApiHandler_getLikelyTenants_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentalManagerRenterContactWebApiHandler_getLikelyTenants_GetKey(postData),
    queryFn: () => RentalManagerRenterContactWebApiHandler_getLikelyTenants(postData, httpClient),
  });
};
useRentalManagerRenterContactWebApiHandler_getLikelyTenants.getKey =
  RentalManagerRenterContactWebApiHandler_getLikelyTenants_GetKey;

export type RentalManagerRenterContactWebApiHandler_getTenancies_Options = UseQueryOptions<
  RentalManagerRenterContactGetTenanciesResponseDto,
  unknown,
  RentalManagerRenterContactGetTenanciesResponseDto,
  Array<string | RentalManagerRenterContactGetTenanciesRequestDto>
>;

const RentalManagerRenterContactWebApiHandler_getTenancies_GetKey = (
  postData: RentalManagerRenterContactGetTenanciesRequestDto,
) => [RentalManagerRenterContactWebApiHandler_getTenancies_Path, postData];

/**
 * Get tenancies, sorted by earliest tenancy start date, then tenant last name
 */
export const useRentalManagerRenterContactWebApiHandler_getTenancies = (
  postData: RentalManagerRenterContactGetTenanciesRequestDto,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerRenterContactWebApiHandler_getTenancies_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentalManagerRenterContactWebApiHandler_getTenancies_GetKey(postData),
    queryFn: () => RentalManagerRenterContactWebApiHandler_getTenancies(postData, httpClient),
  });
};
useRentalManagerRenterContactWebApiHandler_getTenancies.getKey =
  RentalManagerRenterContactWebApiHandler_getTenancies_GetKey;

export type RentalManagerRenterContactWebApiHandler_getTenants_Options = UseQueryOptions<
  RentalManagerRenterContactGetTenantsResponseDto,
  unknown,
  RentalManagerRenterContactGetTenantsResponseDto,
  Array<string | RentalManagerRenterContactGetTenantsRequestDto>
>;

const RentalManagerRenterContactWebApiHandler_getTenants_GetKey = (
  postData: RentalManagerRenterContactGetTenantsRequestDto,
) => [RentalManagerRenterContactWebApiHandler_getTenants_Path, postData];

/**
 * Get tenants grouped by tenant with their tenancies
 */
export const useRentalManagerRenterContactWebApiHandler_getTenants = (
  postData: RentalManagerRenterContactGetTenantsRequestDto,
  {
    httpClient,
    ...options
  }: Omit<RentalManagerRenterContactWebApiHandler_getTenants_Options, 'queryFn' | 'queryKey'> & {
    httpClient?: Client;
  } = {},
) => {
  return useQuery({
    ...tsClientOptions.queryOptions,
    ...options,
    queryKey: RentalManagerRenterContactWebApiHandler_getTenants_GetKey(postData),
    queryFn: () => RentalManagerRenterContactWebApiHandler_getTenants(postData, httpClient),
  });
};
useRentalManagerRenterContactWebApiHandler_getTenants.getKey =
  RentalManagerRenterContactWebApiHandler_getTenants_GetKey;
